(ns minorodata.connections.sources.affiliate-gateway
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "affiliate-gateway"
   :enabled      false
   :name         "The Affiliate Gateway (Deprecated)"
   :description  "The largest affiliate marketing network across Asia Pacific"
   :image-source "affiliate-gateway.svg"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
              (fn [data]
                (let [{:keys [name description username api-key]} data]
                  {:source-type "affiliate-gateway"
                   :name        name
                   :description description

                   :source
                                {:credentials         {:username  username
                                                       :api-key  api-key}}}))

    :format-for-inputs
              (fn [data]
                (let [{:keys [source name description]} data
                      {:keys [credentials]} source]
                  (merge
                    (select-keys credentials [:username :api-key])
                    {:name              name
                     :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :affiliate-gateway-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Username"
              :required   true
              :name       :username
              :value      ""}
             {:block-type :input
              :label      "API Key"
              :required   true
              :name       :api-key
              :type       :password
              :value      ""}
             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
              (fn [data]
                (let [{:keys [name description status action destination-table report]} data]
                  {:name          name
                   :description   description
                   :status        status
                   :output-tables [destination-table]

                   :config
                   {:extracts [{:report            report
                                :destination-table destination-table
                                :action            action}]}}))

    :format-for-inputs
              (fn [data]
                (let [{:extract/keys [name description status config]} data

                      extract (get-in config [:extracts 0])]
                  (merge
                    (select-keys extract [:report :action :destination-table])
                    (app.utils/keep-non-nil-keys
                      {:name          name
                       :description   description
                       :status        status}))))

    :validate (constantly nil)

    :id :affiliate-gateway-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}

             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Endpoint Service"
              :name       :report
              :options    [{:name "Sales Report" :value "sales-report"}]
              :required   true
              :value      "sales-report"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Append"             :value "append"}]
              :required   true
              :value      "append"}

             {:content [:p "Note: Sales Report is incremental by default"]
              :conditions [[:eq [:report :value] "sales-report"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})

